import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const SOURCE_LABELS = {
  client: 'Клієнт',
  student: 'Студент',
  telegram: 'Telegram',
  anonymous: 'Анонім',
};

// Some legacy rows store "null"/"undefined" as a literal string (sometimes
// with stray whitespace) instead of a real null - filter those out too.
function clean(value) {
  if (!value) return '';
  const trimmed = String(value).trim();
  const lower = trimmed.toLowerCase();
  return lower && lower !== 'null' && lower !== 'undefined' ? trimmed : '';
}

export default function ConversationsPeopleWidget() {
  const navigate = useNavigate();
  const [progresses, setProgresses] = useState([]);

  useEffect(() => {
    axios.get('/api/conversationprogress', { withCredentials: true })
      .then(response => setProgresses(response.data || []))
      .catch(() => {});
  }, []);

  const recentPeople = useMemo(() => {
    const byPerson = new Map();
    progresses.forEach(progress => {
      const outerUser = progress.outerUserId;
      const client = progress.client;
      const key = client ? 'client-' + client.id : outerUser ? 'outer-' + outerUser.id : 'meta-' + progress.meta;

      const existing = byPerson.get(key);
      const date = progress.dAdd || '';
      if (existing && existing.date >= date) return;

      let name, source;
      if (client) {
        name = (clean(client.firstName) + ' ' + clean(client.lastName)).trim() || 'Клієнт #' + client.id;
        source = 'client';
      } else if (outerUser) {
        name = (clean(outerUser.name) + ' ' + clean(outerUser.surname)).trim() || clean(outerUser.username) || ('Telegram #' + outerUser.id);
        source = outerUser.studentId ? 'student' : 'telegram';
      } else {
        name = progress.meta || 'Анонім';
        source = 'anonymous';
      }

      byPerson.set(key, { key, name, source, date, isFinished: progress.isFinished === 1 });
    });

    return Array.from(byPerson.values())
      .sort((a, b) => (b.date || '').localeCompare(a.date || ''))
      .slice(0, 8);
  }, [progresses]);

  return (
    <div className="conv-dashboard-section">
      <div className="conv-dashboard-section-header">
        <h4 className="conv-dashboard-section-title">Хто проходить тести</h4>
        <span className="conv-dashboard-link" onClick={() => navigate('/conversationprogress')}>Всі →</span>
      </div>
      {recentPeople.length === 0 ? (
        <p className="conv-dashboard-empty">Ще немає активності</p>
      ) : (
        <ul className="conv-participants-list" style={{maxHeight:335}}>
          {recentPeople.map(person => (
            <li className="conv-participant-row" key={person.key}>
              <span className="conv-participant-avatar">{(person.name || '?').trim().charAt(0).toUpperCase()}</span>
              <span className="conv-participant-name">{person.name}</span>
              <span className={
                'conv-badge ' +
                (person.source === 'client' ? 'conv-badge-function' : person.source === 'student' ? 'conv-badge-published' : 'conv-badge-used')
              }>
                {SOURCE_LABELS[person.source]}
              </span>
              <span className={'conv-participant-status ' + (person.isFinished ? 'done' : 'pending')}>
                {person.isFinished ? 'Завершено' : 'В процесі'}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
